'use strict';

import 'moment/locale/ru';
import { Price } from '../finance';
import Area from '../common/area';

/**
 * Модель объявлений
 * @param object объект объявления
 * @param dictionary объект словаря
 * @constructor
 */
function PremiumAnnouncement (object, dictionary) {
  this.id = object.get('id');
  this.type = dictionary.getObjectType(object.get('objectTypeId'));

  this.uri = object.get('uri');
  this.address = object.get('address');
  this.mainPhoto = object.get('photo');

  this.price = new Price(object.get('price'));

  const landPlot = object.get('landPlot');
  const room = object.get('room');

  if (landPlot) {
    this.totalArea = landPlot.get('totalArea') ? new Area('', landPlot.get('totalArea'), Area.MEASURE_AR) : null;
  } else if (room) {
    this.totalArea = room.get('totalArea') ? new Area('', room.get('totalArea')) : null;
  }
}

const proto = PremiumAnnouncement.prototype;

proto.getId = function () {
  return this.id;
};

proto.getType = function () {
  return this.type;
};

proto.getAddress = function () {
  return this.address;
};

proto.getLink = function () {
  return this.uri;
};

proto.getMainPhoto = function () {
  return this.mainPhoto;
};

/**
 * Цена объявления
 * @returns {Price}
 */
proto.getPrice = function () {
  return this.price;
};

proto.getTotalArea = function () {
  return this.totalArea;
};

export default PremiumAnnouncement;



// WEBPACK FOOTER //
// ./src/classes/announcement/premiumAnnouncement.js